<div class="bg-background min-h-screen text-on-surface">

  <!-- Hero -->
  <section class="relative pt-24 pb-20 overflow-hidden">
    <div class="absolute inset-0 pointer-events-none">
      <div class="absolute top-[-10%] right-1/4 w-[600px] h-[600px] rounded-full bg-primary/5 blur-[120px]"></div>
    </div>
    <div class="max-w-7xl mx-auto px-6 relative z-10">
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div class="lg:col-span-7">
          <span class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-container text-on-secondary-container text-xs font-bold uppercase tracking-wider mb-6">
            <span class="material-symbols-outlined text-[14px]">domain</span>
            Industry Solutions
          </span>
          <h1 class="text-5xl md:text-6xl font-extrabold tracking-tighter text-on-background mb-6 leading-[1.1]">
            Built for Your<br>
            <span class="bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary-container">Industry.</span>
          </h1>
          <p class="text-xl text-on-surface-variant leading-relaxed mb-10 max-w-2xl">
            ZAD ERP doesn't believe in generic software. Every vertical solution is engineered from the ground up to match the real operational complexity of your sector.
          </p>
          <a routerLink="/create-account" class="bg-gradient-to-r from-primary to-primary-container text-white px-10 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-primary/20 transition-all active:scale-95 inline-block text-center">Explore Your Industry</a>
        </div>
        
        <div class="lg:col-span-5 relative hidden lg:block">
          <div class="absolute -top-20 -right-20 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
          <div class="relative bg-surface-container-lowest rounded-2xl p-4 shadow-[0_12px_40px_rgba(25,28,30,0.06)] border border-outline-variant/15 transform lg:rotate-2 lg:hover:rotate-0 transition-transform duration-500">
            <img class="rounded-xl w-full h-auto object-cover aspect-video" alt="ZAD ERP Industry Solutions Dashboard" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDsmD8W4KoEsh4ygziS-wUZhKGPxMikvEBj7lKcU8p9siwSKCd8NtD4Uigyuo1TwpAsTIdIXe92Cy6ReQCODQItQM89C8PPHXNLFJenJclE8F5oFWd5nSIocV_6WfBnjxuDYM3EQC8XBIuSLLRidCTohG9kcQ_P_CokE7RVGU7Inhn6wBFhF8VQ8SBvd9RHDRBeCQa_bIwXP6BQaZgQLo8NqWcQs_X9idlLjyRBwOA5mUY3aXX-nF_dKCLC4MhjcO9vBs3R4EBH4Ms" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Industry Selector + Detail Panel -->
  <section class="py-16 bg-surface-container-low border-y border-outline-variant/10">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex flex-col lg:flex-row gap-8">

        <!-- Left: Industry List -->
        <div class="w-full lg:w-72 flex-shrink-0">
          <p class="text-xs font-bold uppercase tracking-[0.2em] text-on-surface-variant mb-4">Select Your Sector</p>
          <nav class="flex flex-row lg:flex-col gap-2 flex-wrap">
            @for (industry of industries; track industry.id) {
              <button
                (click)="selectedIndustry = industry.id"
                class="flex items-center gap-3 px-4 py-3 rounded-xl text-left font-semibold text-sm transition-all duration-200"
                [ngClass]="selectedIndustry === industry.id
                  ? 'bg-primary text-white shadow-md shadow-primary/20'
                  : 'bg-surface-container-lowest hover:bg-surface-container text-on-surface-variant'">
                <span class="material-symbols-outlined text-[20px]">{{industry.icon}}</span>
                {{industry.name}}
              </button>
            }
          </nav>
        </div>

        <!-- Right: Detail Panel -->
        <div class="flex-1 bg-surface-container-lowest rounded-[2rem] p-8 md:p-12 border border-outline-variant/10 min-h-[500px]">
          <div class="flex flex-col md:flex-row md:items-start gap-6 mb-8">
            <div class="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
              <span class="material-symbols-outlined text-primary text-3xl">{{selectedIndustryData.icon}}</span>
            </div>
            <div>
              <p class="text-xs font-bold uppercase tracking-widest text-on-surface-variant/60 mb-1">{{selectedIndustryData.name}}</p>
              <h2 class="text-2xl md:text-3xl font-extrabold tracking-tight text-on-background mb-4">{{selectedIndustryData.headline}}</h2>
              <p class="text-on-surface-variant leading-relaxed max-w-2xl">{{selectedIndustryData.description}}</p>
            </div>
          </div>

          <!-- Stats -->
          <div class="grid grid-cols-3 gap-4 mb-8">
            @for (stat of selectedIndustryData.stats; track stat.label) {
              <div class="bg-surface-container-low rounded-xl p-4 text-center">
                <p class="text-2xl font-extrabold text-primary">{{stat.value}}</p>
                <p class="text-xs text-on-surface-variant font-medium mt-1 leading-tight">{{stat.label}}</p>
              </div>
            }
          </div>

          <!-- Capabilities -->
          <div>
            <p class="text-xs font-bold uppercase tracking-widest text-on-surface-variant/50 mb-4">Key Capabilities</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              @for (cap of selectedIndustryData.capabilities; track cap.text) {
                <div class="flex items-start gap-3 p-3 rounded-xl bg-surface-container-low">
                  <span class="material-symbols-outlined text-primary text-[20px] mt-0.5 flex-shrink-0">{{cap.icon}}</span>
                  <p class="text-sm text-on-surface leading-snug">{{cap.text}}</p>
                </div>
              }
            </div>
          </div>

          @if (selectedIndustryData.link) {
            <div class="mt-8 pt-6 border-t border-outline-variant/10">
              <a [routerLink]="selectedIndustryData.link" class="inline-flex items-center gap-2 bg-primary text-white px-8 py-3 rounded-xl font-bold text-sm hover:bg-primary-container transition-all">
                {{selectedIndustryData.linkLabel}}
                <span class="material-symbols-outlined text-[16px]">arrow_forward</span>
              </a>
            </div>
          }
        </div>

      </div>
    </div>
  </section>

  <!-- Why ZAD ERP -->
  <section class="py-24 bg-surface">
    <div class="max-w-7xl mx-auto px-6">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight text-on-background mb-4">Why enterprises choose ZAD ERP</h2>
        <p class="text-on-surface-variant max-w-xl mx-auto">Built with industry veterans. Trusted by operators across every sector.</p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10">
          <span class="material-symbols-outlined text-primary text-3xl mb-4 block">tune</span>
          <h3 class="font-bold text-on-surface mb-2">Purpose-Built Workflows</h3>
          <p class="text-sm text-on-surface-variant leading-relaxed">Not generic templates — real workflows designed for your industry's specific processes.</p>
        </div>
        <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10">
          <span class="material-symbols-outlined text-secondary text-3xl mb-4 block">account_balance</span>
          <h3 class="font-bold text-on-surface mb-2">Compliance Ready</h3>
          <p class="text-sm text-on-surface-variant leading-relaxed">VAT, ZATCA, and local regulatory requirements baked in by default across all modules.</p>
        </div>
        <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10">
          <span class="material-symbols-outlined text-tertiary text-3xl mb-4 block">bolt</span>
          <h3 class="font-bold text-on-surface mb-2">Fast Implementation</h3>
          <p class="text-sm text-on-surface-variant leading-relaxed">Go live in days, not months. Pre-configured industry templates cut setup time dramatically.</p>
        </div>
        <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10">
          <span class="material-symbols-outlined text-primary text-3xl mb-4 block">support_agent</span>
          <h3 class="font-bold text-on-surface mb-2">Dedicated Support</h3>
          <p class="text-sm text-on-surface-variant leading-relaxed">Industry-specific specialists on your team to ensure successful adoption and growth.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="py-24 bg-on-background text-white overflow-hidden relative">
    <div class="max-w-7xl mx-auto px-6 text-center relative z-10">
      <h2 class="text-4xl md:text-5xl font-black tracking-tight mb-6">Your industry. Our architecture.</h2>
      <p class="text-lg text-slate-400 mb-10 max-w-2xl mx-auto">Book a free demo to see how ZAD ERP maps to your exact business operations.</p>
      <div class="flex flex-col sm:flex-row justify-center gap-4">
        <a routerLink="/create-account" class="bg-primary text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-primary-container transition-all">Start Free Trial</a>
        <a routerLink="/contact" class="border border-outline-variant/30 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-white/5 transition-all">Request a Demo</a>
      </div>
    </div>
    <div class="absolute -bottom-24 -right-24 w-96 h-96 bg-primary/20 rounded-full blur-[120px]"></div>
    <div class="absolute -top-24 -left-24 w-96 h-96 bg-secondary/10 rounded-full blur-[120px]"></div>
  </section>

</div>
